import ModalNew from "./Modal";
import SmartButton from "../buttons/SmartButton";
import { PopupHeader } from "./common";

const FilterModal = ({
  isOpen,
  onClose,
  onApply,
  applyText,
  applyDisabled = false,
  isLoading = false,
  title,
  children,
}) => {
  if (!isOpen) return null;

  return (
    <ModalNew className="filter-modal">
      <PopupHeader
        title={title}
        setOpenState={onClose}
        icon={`${process.env.PUBLIC_URL}/images/icons/filter_dark_blue.svg`}
        variant="compact"
      />

      <div className="filter-modal-form">
        <div className="filter-controls">
          {/* Renders the dynamic Institution, Account, etc. fields */}
          {children}

          <div className="filter-actions" style={{ marginTop: "20px" }}>
            <SmartButton
              type="button"
              className="cta-button primary"
              text={applyText}
              onClick={onApply}
              disabled={applyDisabled}
              isSubmitting={isLoading}
            />
          </div>
        </div>
      </div>
    </ModalNew>
  );
};

export default FilterModal;
